import React, { FC } from 'react';
import { IOuter } from '../ItemDemonstration.types';

export const Empty: FC<IOuter> = ({ saveRef }) => <div ref={saveRef} />;
